// Adapted from https://github.com/alexreardon/raf-schd/blob/master/src/index.js

export const rafSchedule = (fn: () => void) => {
	let frameId: number | null = null;

	const wrapperFn = () => {
		// There is already a frame queued
		if (frameId) {
			return;
		}

		// Schedule a new frame
		frameId = requestAnimationFrame(() => {
			frameId = null;
			fn();
		});
	};

	// Adding cancel property to result function
	wrapperFn.cancel = () => {
		if (!frameId) {
			return;
		}

		cancelAnimationFrame(frameId);
		frameId = null;
	};

	return wrapperFn;
};
